import { render, staticRenderFns } from "./huanlianMerge.vue?vue&type=template&id=444aa02e"
import script from "./huanlianMerge.vue?vue&type=script&lang=js"
export * from "./huanlianMerge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports